import { type FunctionalComponent, h } from '@stencil/core';
import { ConversationalSearchLabelWithSection } from '../../../conversational-search-partials/label-with-section/label-with-section';
import type { labelProviderInterface } from '../../../../../LabelProviderInterface';

export interface IConversationalSearchNotDetailedAnswerFallback {
  labelProvider: labelProviderInterface;
  query: string;
}

export const ConversationalSearchNotDetailedAnswerFallback: FunctionalComponent<
  IConversationalSearchNotDetailedAnswerFallback
> = (props) => {
    const text = props.labelProvider(
      'conversational.search.not.detailed.fallback.intro',
      'Sorry, but I am not to able to provide results for “{0}”, Could you please clarify your product question?',
    );

    return (
      <div class="conversational-search-messages-not-detailed-answer-fallback">
        <ConversationalSearchLabelWithSection text={text} partial={props.query} />
        <section>
          {props.labelProvider(
            'conversational.search.not.detailed.fallback.outro',
            'Please enter a more detailed description in the below.',
          )}
        </section>
      </div>
    );
};
